// src/services/documentService.ts
import api from './api';
import {
  DocumentListResponse,
  DocumentFilters,
  DocumentStatistics,
  DocumentDetailResponse,
  DeleteDocumentResponse,
} from '../types/document';

const DOCUMENT_ENDPOINTS = {
  list: '/admin/documents',
  statistics: '/admin/documents/statistics',
  detail: (id: number) => `/admin/documents/${id}`,
  delete: (id: number) => `/admin/documents/${id}`,
};

export const getDocuments = async (filters?: DocumentFilters): Promise<DocumentListResponse> => {
  console.log('[DocumentService] Fetching documents:', filters);
  const response = await api.get<DocumentListResponse>(DOCUMENT_ENDPOINTS.list, {
    params: filters,
  });
  console.log('[DocumentService] Documents fetched:', response.data);
  return response.data;
};

export const getDocumentStatistics = async (): Promise<DocumentStatistics> => {
  console.log('[DocumentService] Fetching document statistics...');
  const response = await api.get<DocumentStatistics>(DOCUMENT_ENDPOINTS.statistics);
  console.log('[DocumentService] Document statistics fetched:', response.data);
  return response.data;
};

export const getDocumentById = async (id: number): Promise<DocumentDetailResponse> => {
  console.log('[DocumentService] Fetching document:', id);
  const response = await api.get<DocumentDetailResponse>(DOCUMENT_ENDPOINTS.detail(id));
  console.log('[DocumentService] Document fetched:', response.data);
  return response.data;
};

export const deleteDocument = async (id: number): Promise<DeleteDocumentResponse> => {
  console.log('[DocumentService] Deleting document:', id);
  const response = await api.delete<DeleteDocumentResponse>(DOCUMENT_ENDPOINTS.delete(id));
  console.log('[DocumentService] Document deleted:', response.data);
  return response.data;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getFileTypeLabel = (mimeType: string): string => {
  const typeMap: Record<string, string> = {
    'application/pdf': 'PDF',
    'image/jpeg': 'JPEG',
    'image/jpg': 'JPG',
    'image/png': 'PNG',
    'image/gif': 'GIF',
    'image/webp': 'WebP',
    'application/msword': 'DOC',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
    'application/vnd.ms-excel': 'XLS',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
    'text/plain': 'TXT',
  };
  return typeMap[mimeType] || mimeType.split('/').pop()?.toUpperCase() || 'FILE';
};

const documentService = {
  getDocuments,
  getDocumentStatistics,
  getDocumentById,
  deleteDocument,
  formatFileSize,
  getFileTypeLabel,
};

export default documentService;
